import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'
import {
	getLoginStatus
} from '@/http/api/user'
import {
	getModel
} from '@/http/api/getApi'
import {
	getDept
} from '@/http/api/keshiApi'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		isProxy: true,  // 是否本地解决跨域
		itemName: process.env.VUE_APP_ITEM,
		color: process.env.VUE_APP_ITEM == 'rag' ? '#29ba83' : '#2B64EA',
		color_del: '#99999',
		userInfo: null,
		
		modelValue: ['deepseek', 'deepseek-v3.2-exp'],  // 模型使用默认值
		modelValue_pm: ['deepseek', 'deepseek-v3.2-exp'],  // pm跳转过来的，模型使用默认值
		modelValue_deepThinking: {   // 模型使用默认值   
			isDeepThinking: ['deepseek', 'deepseek-r1'],   //  是深度思考  R1
			notDeepThinking: ['deepseek', 'deepseek-v3.2-exp']   //  不是深度思考  V3
		},
		
		modelData: [], // 模型厂商数据
		deptData: [], // 期刊数据
		expertMode: false,   // 专家模式
	},
	getters: {},
	mutations: {
		setUserInfo(state, data) {
			state.userInfo = data
		},
		setModelData(state, data) {
			state.modelData = data
		},
		setDeptData(state, data) {
			state.deptData = data
		},
		setExpertMode(state, data) {
			state.expertMode = !state.expertMode
		},
	},
	actions: {
		getToken(context) {
			return new Promise((resolve, reject) => {
				getLoginStatus().then(res => {
					if (res.data.token) {
						sessionStorage.setItem('token', res.data.token)
						router.go(0)
					}
				}).catch(error => {})
			})
		},
		getModelData({
			commit,
			state
		}) {
			return new Promise((resolve, reject) => {
				if (state.modelData.length) {
					// console.log('使用已有的');
					resolve(state.modelData);
				} else {
					// console.log('没有找到模型厂商数据，准备异步获取...');
					getModel().then(res => {
						var formattedData = res.data.map(item => {
							item.children = item.models.map(m_item => ({
								label: m_item,
								value: m_item
							}));
							item.label = item.name;
							item.value = item.model;
							return item;
						});
						commit('setModelData', formattedData)
						resolve(formattedData);
					}).catch(error => {
						console.error('获取模型厂商数据失败:', error);
						// reject(error);
					})
				}

			})

		},
		getDeptData({
			commit,
			state
		}) {
			return new Promise((resolve, reject) => {
				if (state.deptData.length) {
					// console.log('使用已有的');
					resolve(state.deptData);
				} else {
					// console.log('没有找到数据，准备异步获取...');
					getDept().then(res => {
						var formattedData = []
						for (var key in res.data) {
							var pot = res.data[key]
							var children = []

							for (var p in pot) {
								var dep = pot[p]
								var d_children = []

								for (var d in dep) {
									d_children.push({
										value: dep[d],
										label: d,
									})
								}
								children.push({
									value: p,
									label: p,
									children: d_children
								})
							}
							formattedData.push({
								value: key,
								label: key == 'fuDan' ? '复旦医院排行' : 'stem排行',
								children: children
							})

						}
						commit('setDeptData', formattedData)
						resolve(formattedData);
					}).catch(error => {
						reject(error);
					})
				}

			})

		}
	},
	modules: {}
})